import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "col-md-5" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-md-5 pe-0" }
const _hoisted_7 = { class: "col-md-3 pe-0" }
const _hoisted_8 = { class: "col-md-3 pe-0" }
const _hoisted_9 = { class: "col-md-1 pe-0" }
const _hoisted_10 = { class: "col-md-12 div-table-boletos box-table" }
const _hoisted_11 = { class: "table table-striped table-hover table-sm table-bordered mb-0" }
const _hoisted_12 = { class: "col-md-12 text-center table-danger" }
const _hoisted_13 = {
  colspan: "15",
  class: "text-center"
}
const _hoisted_14 = { class: "d-inline" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  class: "text-center",
  "data-label": "Opções"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "col-md-7" }
const _hoisted_26 = { class: "row mb-2" }
const _hoisted_27 = { class: "col-md-5 pe-0" }
const _hoisted_28 = { class: "col-md-3 pe-0" }
const _hoisted_29 = { class: "col-md-3 pe-0" }
const _hoisted_30 = { class: "col-md-1 pe-0" }
const _hoisted_31 = { class: "col-md-12 div-table-boletos box-table" }
const _hoisted_32 = { class: "table table-striped table-hover table-sm table-bordered" }
const _hoisted_33 = { class: "col-md-12 text-center table-danger" }
const _hoisted_34 = {
  colspan: "15",
  class: "text-center"
}
const _hoisted_35 = { class: "d-inline" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "text-end" }
const _hoisted_38 = { class: "text-start" }
const _hoisted_39 = { class: "text-start" }
const _hoisted_40 = { class: "text-start" }
const _hoisted_41 = { class: "text-start" }
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = {
  key: 1,
  class: "row"
}
const _hoisted_44 = { class: "col-md-12 d-print-none" }
const _hoisted_45 = { class: "col-md-12" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-12 col-sm-12 overflow-auto" }
const _hoisted_48 = {
  class: "tabela table-print table-sm table-bordered tabela-completa table-striped w-100",
  id: "tabela-linear-sintetico"
}
const _hoisted_49 = { class: "text-end" }
const _hoisted_50 = { class: "text-start" }
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = { class: "text-center" }
const _hoisted_53 = { class: "text-end" }
const _hoisted_54 = { class: "text-end" }
const _hoisted_55 = { class: "text-end" }
const _hoisted_56 = { class: "text-end" }
const _hoisted_57 = { class: "text-start" }
const _hoisted_58 = { class: "text-end fw-bold" }
const _hoisted_59 = { class: "text-end fw-bold" }
const _hoisted_60 = { class: "text-end fw-bold" }
const _hoisted_61 = {
  class: "text-start fw-bold",
  colspan: "2"
}
const _hoisted_62 = { class: "card-footer" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-md-5" }
const _hoisted_65 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_66 = { class: "col-md-10" }
const _hoisted_67 = { class: "col-md-2" }
const _hoisted_68 = { class: "col-md-7" }

import { onMounted, reactive, } from "vue";

//servicos
import * as service from "@/services/BoletosService";
import { f2dec, fdataHora, fdata } from "@/utils/funcoes";

//componentes
import TextBox from "@/components/TextBox/Index.vue";
import Paginador from "@/components/Paginador/Index.vue"
import Loading from "@/components/Loading/index.vue"
import BreadCrumb from "@/components/Common/BreadCrumb.vue";

import ReportView from "@/components/ReportView/Index.vue";
import CabecalhoRelatorio from "@/components/CabecalhoRelatorio/index.vue";
import { AxiosResponse } from "axios";

//janelas

interface IGrupo {
    ocorrenciaId: string;
    descricao: string;
    itens: service.BoletoRemessaItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Remessas',
  setup(__props) {


//vue
var controle = reactive({
    remessas: [] as service.BoletoRemessa[],
    totalRemessas: 0 as number,

    remessaId: 0 as number,
    remessa: {} as service.BoletoRemessa,
    itens: [] as service.BoletoRemessaItem[],
    itemId: 0 as number,
    totalItens: 0 as number,

    grupos: [] as IGrupo[],
    impressao: false,

    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

});

var filtros = reactive<service.RemessaFiltros>({
    paginaAtual: 1,
    tamanhoPagina: 20
})

onMounted(() => {
    pesquisar();
})

const pesquisar = async () => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    //controle.itens = [] as service.BoletoRemessa[];

    service.obterRemessas(filtros)
        .then((r) => {
            controle.pesquisando = false;
            controle.status = "";
            controle.remessas = r.dados;
            controle.totalRemessas = r.totalRegistros;
        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};

function obterItens(remessa: service.BoletoRemessa) {
    controle.remessaId = remessa.remessaId;

    controle.loading = true;
    controle.status = "Obtendo detalhes da remessa...";

    controle.remessa = remessa;

    service.obterRemessa({ remessaId: remessa.remessaId })
        .then((r) => {
            controle.remessa = r;
            controle.itens = r.itens ?? [];
            controle.totalItens = controle.itens.length;
            controle.loading = false;
            controle.status = "";
        })
        .catch((erro: string) => {
            controle.loading = false;
            controle.status = "";
        });
}

function prepararImpressao(remessa: service.BoletoRemessa) {
    if (controle.remessaId != remessa.remessaId) {
        controle.remessaId = remessa.remessaId;
        obterItens(remessa);
    }

    //agrupar por ocorrenciaId no objeto IGrupo 
    controle.grupos = [];
    controle.itens.forEach(item => {
        var grupo = controle.grupos.find(g => g.ocorrenciaId === item.ocorrenciaId);
        if (!grupo) {
            grupo = {
                ocorrenciaId: item.ocorrenciaId,
                descricao: item.ocorrencia.descricao,
                itens: []
            };
            controle.grupos.push(grupo);
        }
        grupo.itens.push(item);
    });

    controle.impressao = true;
}



function baixar(item: service.BoletoRemessa) {
    controle.loading = true;
    controle.status = "Baixando arquivo de remessa...";
    console.log("Baixando remessa", item);

    service.baixarRemessa(item.remessaId)
        .then((r: AxiosResponse) => {
            controle.loading = false;
            controle.status = "";


            // Cria um URL para o blob
            const urlBlob = window.URL.createObjectURL(new Blob([r.data]));

            // Cria um link temporário
            const link = document.createElement('a');
            link.href = urlBlob;
            link.setAttribute('download', item.arquivo); // Define o nome do arquivo
            document.body.appendChild(link);
            link.click(); // Simula o clique no link
            document.body.removeChild(link); // Remove o link
            window.URL.revokeObjectURL(urlBlob);
        })
        .catch((erro: string) => {
            controle.loading = false;
            controle.status = "";
            controle.erro = erro;
        });
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading, {
      isLoading: _unref(controle).loading,
      mensagem: _unref(controle).status
    }, null, 8, ["isLoading", "mensagem"]),
    _createVNode(BreadCrumb, {
      PageTitle: "Remessas",
      items: [{label: 'Inicio', to: '/'}, {label: 'Boletos', to: '/boletos'}, {label: 'Remessas', to: '/boletos/remessas'}]
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(controle).impressao == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(TextBox, {
                      label: "Convênio",
                      modelValue: _unref(filtros).paramBoletoId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filtros).paramBoletoId) = $event)),
                      class: "form-control form-control-sm"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      label: "Data Inicial",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filtros).dataInicial) = $event)),
                      type: "date",
                      class: "form-control form-control-sm"
                    }, null, 512), [
                      [_vModelText, _unref(filtros).dataInicial]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      label: "Data Final",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filtros).dataFinal) = $event)),
                      type: "date",
                      class: "form-control form-control-sm"
                    }, null, 512), [
                      [_vModelText, _unref(filtros).dataFinal]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("a", {
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (pesquisar()))
                    }, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("i", { class: "fa fa-search" }, null, -1)
                    ]))])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("table", _hoisted_11, [
                    _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "th-fixed" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "text-center" }),
                        _createElementVNode("th", { class: "text-end" }, "Id"),
                        _createElementVNode("th", { class: "text-center" }, "Data"),
                        _createElementVNode("th", { class: "text-start" }, "Convênio"),
                        _createElementVNode("th", { class: "text-end" }, "Remessa"),
                        _createElementVNode("th", { class: "text-end" }, "Itens"),
                        _createElementVNode("th", { class: "text-end" }, "Total R$")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _withDirectives(_createElementVNode("tr", _hoisted_12, [
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-exclamation" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_unref(controle).erro), 1)
                          ]),
                          _createElementVNode("a", {
                            class: "btn btn-primary btn-sm",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (pesquisar()))
                          }, "Repetir")
                        ])
                      ], 512), [
                        [_vShow, _unref(controle).erro != '']
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).remessas, (item, idx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: idx,
                          class: _normalizeClass(_unref(controle).remessaId == item.remessaId ? 'table-active' : ''),
                          onClick: ($event: any) => (obterItens(item))
                        }, [
                          _createElementVNode("td", _hoisted_16, [
                            _createElementVNode("a", {
                              class: "",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => {prepararImpressao(item);},
                              title: "Exibir detalhes da remessa"
                            }, [...(_cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "fa fa-print" }, null, -1)
                            ]))], 8, _hoisted_17),
                            _createElementVNode("a", {
                              class: "ms-2",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => {baixar(item);},
                              title: "Baixar remessa"
                            }, [...(_cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "fa fa-download" }, null, -1)
                            ]))], 8, _hoisted_18)
                          ]),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(item.remessaId), 1),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(fdataHora)(item.dataRemessa)), 1),
                          _createElementVNode("td", _hoisted_21, _toDisplayString(item.paramBoleto?.cedenteCodigo), 1),
                          _createElementVNode("td", _hoisted_22, _toDisplayString(item.numeroRemessa), 1),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(item.qtdeItens), 1),
                          _createElementVNode("td", _hoisted_24, _toDisplayString(_unref(f2dec)(item.total)), 1)
                        ], 10, _hoisted_15))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(TextBox, {
                      placeholder: "Pesquisar nome, cliente",
                      modelValue: _unref(filtros).paramBoletoId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filtros).paramBoletoId) = $event)),
                      class: "form-control form-control-sm"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      label: "Data Inicial",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(filtros).dataInicial) = $event)),
                      type: "date",
                      class: "form-control form-control-sm"
                    }, null, 512), [
                      [_vModelText, _unref(filtros).dataInicial]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      label: "Data Final",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(filtros).dataFinal) = $event)),
                      type: "date",
                      class: "form-control form-control-sm"
                    }, null, 512), [
                      [_vModelText, _unref(filtros).dataFinal]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("a", {
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (pesquisar()))
                    }, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("i", { class: "fa fa-search" }, null, -1)
                    ]))])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("table", _hoisted_32, [
                    _cache[20] || (_cache[20] = _createElementVNode("thead", { class: "th-fixed" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "text-end" }, "Id"),
                        _createElementVNode("th", { class: "text-center" }, "Ocorrência"),
                        _createElementVNode("th", { class: "text-start" }, "Cliente"),
                        _createElementVNode("th", { class: "text-start" }, "Nome"),
                        _createElementVNode("th", { class: "text-start" }, "Vencimento"),
                        _createElementVNode("th", { class: "text-end" }, "Valor R$"),
                        _createElementVNode("th", { class: "text-center" })
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _withDirectives(_createElementVNode("tr", _hoisted_33, [
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa fa-exclamation" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_unref(controle).erro), 1)
                          ]),
                          _createElementVNode("a", {
                            class: "btn btn-primary btn-sm",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (pesquisar()))
                          }, "Repetir")
                        ])
                      ], 512), [
                        [_vShow, _unref(controle).erro != '']
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: idx,
                          class: _normalizeClass(_unref(controle).itemId == item.id ? 'table-active' : ''),
                          onClick: ($event: any) => {_unref(controle).itemId = item.id;}
                        }, [
                          _createElementVNode("td", _hoisted_37, _toDisplayString(item.id), 1),
                          _createElementVNode("td", _hoisted_38, _toDisplayString(item.ocorrenciaId) + " " + _toDisplayString(item.ocorrencia?.descricao), 1),
                          _createElementVNode("td", _hoisted_39, _toDisplayString(item.boleto?.clienteId), 1),
                          _createElementVNode("td", _hoisted_40, _toDisplayString(item.boleto?.sacadoNome), 1),
                          _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(fdata)(item.boleto?.dataVencimento)), 1),
                          _createElementVNode("td", _hoisted_42, _toDisplayString(_unref(f2dec)(item.boleto?.valorDocumento)), 1),
                          _cache[19] || (_cache[19] = _createElementVNode("td", {
                            class: "text-center",
                            "data-label": "Opções"
                          }, [
                            _createElementVNode("a", {
                              class: "",
                              href: "javascript:void(0)",
                              title: "Exibir detalhes do boleto"
                            }, [
                              _createElementVNode("i", { class: "fa fa-search" })
                            ])
                          ], -1))
                        ], 10, _hoisted_36))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(controle).impressao == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("a", {
                  class: "btn btn-primary btn-sm mb-2",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(controle).impressao = false))
                }, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("i", { class: "fa fa-close" }, null, -1),
                  _createTextVNode(" Fechar impressão ", -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(ReportView, { titulo: 'Detalhes da remessa' }, {
                  default: _withCtx(() => [
                    _cache[24] || (_cache[24] = _createElementVNode("hr", null, null, -1)),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).grupos, (grupo, idx1) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: idx1 }, [
                            _createElementVNode("h5", null, _toDisplayString(grupo.ocorrenciaId) + " - " + _toDisplayString(grupo.descricao), 1),
                            _createElementVNode("table", _hoisted_48, [
                              _cache[23] || (_cache[23] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", { class: "table-relatorio" }, [
                                  _createElementVNode("th", { class: "text-end" }, "Pedido"),
                                  _createElementVNode("th", { class: "text-start" }, "Nosso número"),
                                  _createElementVNode("th", { class: "text-center" }, "Emissão"),
                                  _createElementVNode("th", { class: "text-center" }, "Vencimento"),
                                  _createElementVNode("th", { class: "text-end" }, "Valor R$"),
                                  _createElementVNode("th", { class: "text-end" }, "Desc R$"),
                                  _createElementVNode("th", { class: "text-end" }, "Total R$"),
                                  _createElementVNode("th", { class: "text-end" }, "Cliente"),
                                  _createElementVNode("th", { class: "text-start" }, "Razão Social")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.itens, (item, idx) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                    _createElementVNode("td", _hoisted_49, _toDisplayString(item.boleto?.pedidoId), 1),
                                    _createElementVNode("td", _hoisted_50, _toDisplayString(item.boleto?.nossoNumero), 1),
                                    _createElementVNode("td", _hoisted_51, _toDisplayString(_unref(fdata)(item.boleto?.dataDocumento)), 1),
                                    _createElementVNode("td", _hoisted_52, _toDisplayString(_unref(fdata)(item.boleto?.dataVencimento)), 1),
                                    _createElementVNode("td", _hoisted_53, _toDisplayString(_unref(f2dec)(item.boleto?.valorDocumento)), 1),
                                    _createElementVNode("td", _hoisted_54, _toDisplayString(_unref(f2dec)(item.boleto?.vlrDesconto)), 1),
                                    _createElementVNode("td", _hoisted_55, _toDisplayString(_unref(f2dec)(item.boleto?.valorDocumento -
                                                    item.boleto?.vlrDesconto)), 1),
                                    _createElementVNode("td", _hoisted_56, _toDisplayString(item.boleto?.clienteId), 1),
                                    _createElementVNode("td", _hoisted_57, _toDisplayString(item.boleto?.sacadoNome), 1)
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("tfoot", null, [
                                _createElementVNode("tr", null, [
                                  _cache[22] || (_cache[22] = _createElementVNode("td", {
                                    class: "text-start",
                                    colspan: "4"
                                  }, null, -1)),
                                  _createElementVNode("td", _hoisted_58, _toDisplayString(_unref(f2dec)(grupo.itens.reduce((acc, item) =>
                                                    acc + (item.boleto?.valorDocumento || 0), 0))), 1),
                                  _createElementVNode("td", _hoisted_59, _toDisplayString(_unref(f2dec)(grupo.itens.reduce((acc, item) =>
                                                    acc + (item.boleto?.vlrDesconto || 0), 0))), 1),
                                  _createElementVNode("td", _hoisted_60, _toDisplayString(_unref(f2dec)(grupo.itens.reduce((acc, item) =>
                                                    acc + ((item.boleto?.valorDocumento || 0) -
                                                    (item.boleto?.vlrDesconto || 0)), 0))), 1),
                                  _createElementVNode("td", _hoisted_61, _toDisplayString(grupo.itens.length) + " Itens ", 1)
                                ])
                              ])
                            ])
                          ], 64))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            (_unref(controle).impressao == false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(Paginador, {
                      paginaAtual: _unref(filtros).paginaAtual ?? 1,
                      tamanhoPagina: _unref(filtros).tamanhoPagina ?? 10,
                      totalRegistros: _unref(controle).totalRemessas ?? 0,
                      onOnChange: _cache[11] || (_cache[11] = (r) => {
                                    _unref(filtros).paginaAtual = r.paginaAtual;
                                    _unref(filtros).tamanhoPagina = r.tamanhoPagina;
                                    pesquisar();
                                })
                    }, null, 8, ["paginaAtual", "tamanhoPagina", "totalRegistros"])
                  ]),
                  _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(controle).remessas.length) + " Itens ", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-sm btn-primary me-1 float-end",
              to: "/boletos",
              title: "Fechar"
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode(" Fechar ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 64))
}
}

})